/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type { AppInstallViewModel, AppSyncData } from '.././model';
import { useCustomInstance } from '.././mutator/custom-instance';

export const useAppInstallGetInstallDataHook = () => {
  const appInstallGetInstallData = useCustomInstance<AppInstallViewModel>();

  return useCallback(
    (signal?: AbortSignal) => {
      return appInstallGetInstallData({
        url: `/api/AppInstall/GetInstallData`,
        method: 'GET',
        signal,
      });
    },
    [appInstallGetInstallData]
  );
};

export const getAppInstallGetInstallDataQueryKey = () => {
  return [`/api/AppInstall/GetInstallData`] as const;
};

export const useAppInstallGetInstallDataQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAppInstallGetInstallDataHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAppInstallGetInstallDataHook>>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAppInstallGetInstallDataQueryKey();

  const appInstallGetInstallData = useAppInstallGetInstallDataHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useAppInstallGetInstallDataHook>>>
  > = ({ signal }) => appInstallGetInstallData(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAppInstallGetInstallDataHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AppInstallGetInstallDataQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAppInstallGetInstallDataHook>>>
>;
export type AppInstallGetInstallDataQueryError = unknown;

export const useAppInstallGetInstallData = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAppInstallGetInstallDataHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAppInstallGetInstallDataHook>>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useAppInstallGetInstallDataQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAppInstallManifestHook = () => {
  const appInstallManifest = useCustomInstance<Blob>();

  return useCallback(
    (signal?: AbortSignal) => {
      return appInstallManifest({
        url: `/api/AppInstall/Manifest`,
        method: 'GET',
        responseType: 'blob',
        signal,
      });
    },
    [appInstallManifest]
  );
};

export const getAppInstallManifestQueryKey = () => {
  return [`/api/AppInstall/Manifest`] as const;
};

export const useAppInstallManifestQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAppInstallManifestHook>>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAppInstallManifestHook>>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAppInstallManifestQueryKey();

  const appInstallManifest = useAppInstallManifestHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useAppInstallManifestHook>>>
  > = ({ signal }) => appInstallManifest(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAppInstallManifestHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AppInstallManifestQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAppInstallManifestHook>>>
>;
export type AppInstallManifestQueryError = unknown;

export const useAppInstallManifest = <
  TData = Awaited<ReturnType<ReturnType<typeof useAppInstallManifestHook>>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAppInstallManifestHook>>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useAppInstallManifestQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAppInstallGetAppSyncDataHook = () => {
  const appInstallGetAppSyncData = useCustomInstance<AppSyncData>();

  return useCallback(
    (signal?: AbortSignal) => {
      return appInstallGetAppSyncData({
        url: `/api/AppInstall/GetAppSyncData`,
        method: 'GET',
        signal,
      });
    },
    [appInstallGetAppSyncData]
  );
};

export const getAppInstallGetAppSyncDataQueryKey = () => {
  return [`/api/AppInstall/GetAppSyncData`] as const;
};

export const useAppInstallGetAppSyncDataQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAppInstallGetAppSyncDataHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAppInstallGetAppSyncDataHook>>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAppInstallGetAppSyncDataQueryKey();

  const appInstallGetAppSyncData = useAppInstallGetAppSyncDataHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useAppInstallGetAppSyncDataHook>>>
  > = ({ signal }) => appInstallGetAppSyncData(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAppInstallGetAppSyncDataHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AppInstallGetAppSyncDataQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAppInstallGetAppSyncDataHook>>>
>;
export type AppInstallGetAppSyncDataQueryError = unknown;

export const useAppInstallGetAppSyncData = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAppInstallGetAppSyncDataHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAppInstallGetAppSyncDataHook>>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useAppInstallGetAppSyncDataQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
